import { useEffect, useState } from "react";

const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState({
    hide: false,
    direction: true,
  });

  useEffect(() => {
    let lastScrollY = window.pageYOffset || document.documentElement.scrollTop;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      const direction = scrollY > lastScrollY ? "down" : "up";

      if (scrollY > 40 && direction === "down") {
        setScrollDirection((prev) => {
          return { ...prev, hide: true };
        });
      } else if (scrollY < 50) {
        setScrollDirection((prev) => {
          return { ...prev, hide: false };
        });
      }

      if (
        direction !== scrollDirection.direction &&
        (scrollY - lastScrollY > 5 || scrollY - lastScrollY < -5)
      ) {
        setScrollDirection((prev) => {
          return { ...prev, direction: direction };
        });
      }

      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    const handleScroll = () => updateScrollDirection();

    window.addEventListener("scroll", handleScroll);
    
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollDirection]);

  return scrollDirection;
};

export default useScrollDirection;
